import React,{ useState, useEffect } from 'react';
import {
  Button,
  makeStyles,
  PropTypes,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root:{}
}));

var timer:any

interface CountdownButtonProps {
  startCount:boolean
  time:number
  title:string
  onTimeout?:()=>void
  onClick?:()=>void
  color?:PropTypes.Color
  disabled?:boolean
  fullWidth?:boolean
  size?: 'small' | 'medium' | 'large'
  variant?: 'text' | 'outlined' | 'contained'
  textStyle?:any
}
const CountdownButton: React.FC<CountdownButtonProps> = ({
  startCount,
  color,
  disabled,
  fullWidth,
  size,
  variant,
  time,
  title,
  onTimeout,
  textStyle,
  onClick,
}) => {

  const classes = useStyles();
  const [timeLeft,setTimeLeft] = useState<number>(time)

  useEffect(()=>{
    timer = setInterval(()=>{
      if (startCount) {
          setTimeLeft((timeLeft)=>Math.max(timeLeft-1,0))
        }
    },1000)
    return () => {
      clearInterval(timer)
    }
  },[startCount])

  useEffect(()=>{
    if (timeLeft <= 0) {
      clearInterval(timer)
      if (onTimeout) onTimeout()
    }
  },[timeLeft,onTimeout])

  return (
    <div className={classes.root}>
      <Button 
        color={color} 
        disabled={disabled} 
        fullWidth={fullWidth} 
        size={size}
        variant={variant}
        onClick={onClick}
      >
        <Typography style={{...textStyle}}>
          {`${title} ใน ${timeLeft} วินาที`}
        </Typography>
      </Button>
    </div>
  )
}

export default CountdownButton;
